// extracted by mini-css-extract-plugin
module.exports = {"body":"ListStables_body__1E3ja"};